import React, { useEffect } from "react";
import { Tooltip, Table } from "antd";
import { useFullOrderModel, FullOrderEnum } from "../fullOrderModel"
import { formatNum, repairFormatNum } from '@/utils/utils';
import { ColumnsType } from 'antd/lib/table';
import useGlobalModel from '@/model/globalModel';

export function DataTable() {
    const {
        dataSource,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        fullOrderStatus,
        loading,
        setSelectedRowKeys,
        purchaseLoadData,
        getTreeNodeName,
        saleLoadData,
        repairLoadData,
        busSaleLoadData,
        goPurchaseDetail,
        goSaleDetail,
        goRepairDetail,
        goBusSaleDetail,
    } = useFullOrderModel()
    const { userBranch } = useGlobalModel()

    // 采购
    const purchaseColumns: ColumnsType<any> = [
        {
            title: '序号',
            width: 80,
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        }, {
            title: '供应商名称',
            align: "center",
            width: 260,
            dataIndex: 'supplierName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '单据编号',
            align: "center",
            width: 180,
            dataIndex: "documentNumber",
            render: (t, r) => {
                return <Tooltip placement="topLeft" title={t} arrowPointAtCenter><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goPurchaseDetail(t, r) }}>{t}</p></Tooltip>;
            }
        }, {
            title: '单据类型',
            align: "center",
            width: 180,
            dataIndex: 'tradeTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '采/退数量',
            align: "center",
            width: 180,
            dataIndex: 'totalNum',
            render: (text) => text === null || text === '' ? 0 : text
        }, {
            title: '已付/收金额',
            align: "center",
            width: 180,
            dataIndex: 'amount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '采购/退金额',
            align: "center",
            width: 180,
            dataIndex: 'totalAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '单据状态',
            align: "center",
            width: 180,
            dataIndex: 'status',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '支付状态',
            align: "center",
            width: 180,
            dataIndex: 'payStatus',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '结算类型',
            align: "center",
            width: 180,
            dataIndex: 'payType',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '备注',
            align: "center",
            width: 180,
            dataIndex: 'note',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '结算方式',
            align: "center",
            width: 180,
            dataIndex: 'payMethodName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '发票类型',
            align: "center",
            width: 180,
            dataIndex: 'invoiceTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '制单员',
            align: "center",
            width: 180,
            dataIndex: 'createUser',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '制单时间',
            align: "center",
            width: 180,
            dataIndex: 'createTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '库管员',
            align: "center",
            width: 180,
            dataIndex: 'storekeeper',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '入/出库时间',
            align: "center",
            width: 180,
            dataIndex: 'stockIoTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算员',
            align: "center",
            width: 180,
            dataIndex: 'reckoner',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算日期',
            align: "center",
            width: 180,
            dataIndex: 'settleTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '核销日期',
            align: "center",
            width: 180,
            dataIndex: 'writeOffTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '作废原因',
            align: "center",
            width: 180,
            dataIndex: 'cancelReason',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '赠品数量',
            align: "center",
            width: 180,
            dataIndex: 'giftsNum',
            render: (text) => text === null || text === '' ? 0 : text
        }, {
            title: '优惠总金额',
            align: "center",
            width: 180,
            dataIndex: 'preferentialAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '采购类型',
            align: "center",
            width: 180,
            dataIndex: 'orderTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '开票状态',
            align: "center",
            width: 80,
            dataIndex: 'invoiceStatus',
            render: (text) => text === 1 ? "已开票" : "未开票"
        },
    ];

    // 销售
    const saleColumns: ColumnsType<any> = [
        {
            title: '序号',
            width: 80,
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        }, {
            title: '单据编号',
            align: "center",
            width: 180,
            dataIndex: "documentNumber",
            render: (t, r) => {
                return <Tooltip placement="topLeft" title={t} arrowPointAtCenter><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goSaleDetail(t, r) }}>{t}</p></Tooltip>;
            }
        }, {
            title: '单据类型',
            align: "center",
            width: 180,
            dataIndex: 'tradeTypeName',
            // render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '客户名称',
            align: "center",
            width: 260,
            dataIndex: 'customerName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '结算方',
            align: "center",
            width: 180,
            dataIndex: 'settlementPartyName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '单据状态',
            align: "center",
            width: 180,
            dataIndex: 'status',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '支付状态',
            align: "center",
            width: 180,
            dataIndex: 'payStatus',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '销售类型',
            align: "center",
            width: 180,
            dataIndex: 'salesTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '销售/退数量',
            align: "center",
            width: 180,
            dataIndex: 'totalNum',
            render: (text) => text === null || text === '' ? 0 : text
        }, {
            title: '销售/退金额',
            align: "center",
            width: 180,
            dataIndex: 'totalAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        },
        {
            title: '优惠类型',
            align: "center",
            width: 180,
            dataIndex: 'preferentialTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '已收/付金额',
            align: "center",
            width: 180,
            dataIndex: 'receivedAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '销售/退成本',
            align: "center",
            width: 180,
            dataIndex: 'totalCost',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '销售/退毛利',
            align: "center",
            width: 180,
            dataIndex: 'grossProfit',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '结算类型',
            align: "center",
            width: 180,
            dataIndex: 'payType',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        },
        {
            title: '结算方式',
            align: "center",
            width: 180,
            dataIndex: 'paymentMethodName',
            render: (text) => text === null || text === '' ? "暂无" : text

        }, {
            title: '开票状态',
            align: "center",
            width: 80,
            dataIndex: 'invoiceStatus',
            render: (text) => text === 1 ? "已开票" : "未开票"
        }, {
            title: '发票类型',
            align: "center",
            width: 180,
            dataIndex: 'invoiceTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text

        }, {
            title: '制单员',
            align: "center",
            width: 180,
            dataIndex: 'createUser',
            render: (text) => text === null || text === '' ? "暂无" : text

        }, {
            title: '制单时间',
            align: "center",
            width: 180,
            dataIndex: 'createTime',
            render: (text) => text === null || text === '' ? "暂无" : text

        }, {
            title: '库管员',
            align: "center",
            width: 180,
            dataIndex: 'storekeeper',
            render: (text) => text === null || text === '' ? "暂无" : text

        }, {
            title: '入/出库时间',
            align: "center",
            width: 180,
            dataIndex: 'stockIoTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算员',
            align: "center",
            width: 180,
            dataIndex: 'reckoner',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算日期',
            align: "center",
            width: 180,
            dataIndex: 'settleTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '核销日期',
            align: "center",
            width: 180,
            dataIndex: 'writeOffTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '作废原因',
            align: "center",
            width: 180,
            dataIndex: 'cancelReason',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '备注',
            align: "center",
            width: 180,
            dataIndex: 'note',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '财务备注',
            align: "center",
            width: 180,
            dataIndex: 'fmsNote',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        },
    ];

    // 维修
    const repairColumns: ColumnsType<any> = [
        {
            title: '序号',
            width: 80,
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        },
        {
            title: '单据编号',
            align: "center",
            width: 180,
            dataIndex: "documentNumber",
            render: (t, r) => {
                return <Tooltip placement="topLeft" title={t} arrowPointAtCenter><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goRepairDetail(t, r) }}>{t}</p></Tooltip>;
            }
        },
        {
            title: '单据类型',
            align: "center",
            width: 100,
            dataIndex: 'tradeTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        },
        {
            title: '客户名称',
            align: "center",
            width: 260,
            dataIndex: 'customerName',
            render: (t, r) => <Tooltip placement="topLeft" title={t}><p className="ellipsis">{t}</p></Tooltip>,
        }, {
            title: '单据状态',
            align: "center",
            width: 80,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'orderStatus':'statusName',
            render: (text) => text === null || text === '' ? "暂无" : text
        },
        {
            title: '支付状态',
            align: "center",
            width: 80,
            dataIndex: 'payStatus',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        },
        {
            title: '结算类型',
            align: "center",
            width: 100,
            dataIndex: 'payType',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '结算方式',
            align: "center",
            width: 80,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'paymentmethodName':'paymentMethodName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算方',
            align: "center",
            width: 180,
            dataIndex: 'settlementPartyName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '维修类型',
            align: "center",
            width: 120,
            dataIndex: 'serviceNatureName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '配件数',
            align: "center",
            width: 120,
            dataIndex: 'materialNum',
            render: (text) => text === null || text === '' ? 0 : text
        }, {
            title: '工时数',
            align: "center",
            width: 120,
            dataIndex: 'workHour',
            render: (text) => text === null || text === '' ? 0 : text
        }, {
            title: '配件费',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'materialTotalSumAmount':'materialScienceAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '工时费',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'itemTotalSumAmount':'workingHoursAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '费用合计',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'orderTotalAmount':'totalAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '优惠金额',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'orderDiscountAndPreferentialTotalAmount':'discountTotalAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '优惠后工时费',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'itemActualSumAmount':'workHourAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '优惠后配件费',
            align: "center",
            width: 120,
            dataIndex:fullOrderStatus == FullOrderEnum.ciRepair?'materialActualSumAmount': 'materialHourAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '营业额',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'orderActualAmount':'receivableTotalAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '已收金额',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'fmsSettlementAmount':'receivableAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '销售成本',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'materialCostSumAmount':'totalCost',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '销售毛利',
            align: "center",
            width: 120,
            dataIndex: fullOrderStatus == FullOrderEnum.ciRepair?'materialGrossProfitAmount':'grossProfit',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '服务地点',
            align: "center",
            width: 250,
            dataIndex: 'serviceLocationName',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '制单员',
            align: "center",
            width: 120,
            dataIndex: 'createUser',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '制单时间',
            align: "center",
            width: 180,
            dataIndex: 'createTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '库管员',
            align: "center",
            width: 120,
            dataIndex: 'storekeeper',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '入/出库时间',
            align: "center",
            width: 180,
            dataIndex: 'stockIoTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算员',
            align: "center",
            width: 120,
            dataIndex: 'reckoner',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算日期',
            align: "center",
            width: 180,
            dataIndex: 'settleTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '核销日期',
            align: "center",
            width: 180,
            dataIndex: 'writeOffTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '作废原因',
            align: "center",
            width: 180,
            dataIndex: 'cancelReason',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '备注',
            align: "center",
            width: 180,
            dataIndex: 'note',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '财务备注',
            align: "center",
            width: 180,
            dataIndex: 'fmsNote',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '开票状态',
            align: "center",
            width: 120,
            dataIndex: 'invoiceStatus',
            render: (text) => text === 1 ? "已开票" : "未开票"
        }, {
            title: '发票类型',
            align: "center",
            width: 180,
            dataIndex: 'invoiceTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        },
    ];

    // 公交销售
    const busColumns: ColumnsType<any> = [
        {
            title: '序号',
            width: 80,
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        },
        {
            title: '单据编号',
            align: "center",
            width: 180,
            dataIndex: "documentNumber",
            render: (t, r) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goBusSaleDetail(t, r) }}>{t}</p>
            </Tooltip>
        }, {
            title: '单据类型',
            align: "center",
            width: 180,
            dataIndex: 'tradeTypeName',
            render: (text) => text === null || text === '' ? 0 : text
        },
        {
            title: '客户名称',
            align: "center",
            width: 260,
            dataIndex: 'customerName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '单据状态',
            align: "center",
            width: 180,
            dataIndex: 'status',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        },
        {
            title: '支付状态',
            align: "center",
            width: 180,
            dataIndex: 'payStatus',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        },
        {
            title: '结算类型',
            align: "center",
            width: 180,
            dataIndex: 'payType',
            render: (text) => text === null || text === '' ? "暂无" : getTreeNodeName(text)
        }, {
            title: '结算方式',
            align: "center",
            width: 180,
            dataIndex: 'paymentMethodName',
            render: (text) => text === null || text === '' ? '暂无' : text
        }, {
            title: '结算方',
            align: "center",
            width: 180,
            dataIndex: 'settlementPartyName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '销售/退数量',
            align: "center",
            width: 180,
            dataIndex: 'totalNum',
            render: (text) => text === null || text === '' ? 0 : text
        }, {
            title: '销售/退金额',
            align: "center",
            width: 180,
            dataIndex: 'totalAmount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '已收/付金额',
            align: "center",
            width: 180,
            dataIndex: 'amount',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '销售/退成本',
            align: "center",
            width: 180,
            dataIndex: 'totalCost',
            render: (text) => text === null || text === '' ? `￥${repairFormatNum(0)}` : `￥${repairFormatNum(text)}`
        }, {
            title: '制单员',
            align: "center",
            width: 180,
            dataIndex: 'createUser',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '制单时间',
            align: "center",
            width: 180,
            dataIndex: 'createTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '库管员',
            align: "center",
            width: 180,
            dataIndex: 'storekeeper',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '入/出库时间',
            align: "center",
            width: 180,
            dataIndex: 'stockIoTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算员',
            align: "center",
            width: 180,
            dataIndex: 'reckoner',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '结算日期',
            align: "center",
            width: 180,
            dataIndex: 'settleTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '核销日期',
            align: "center",
            width: 180,
            dataIndex: 'writeOffTime',
            render: (text) => text === null || text === '' ? "暂无" : text
        }, {
            title: '备注',
            align: "center",
            width: 180,
            dataIndex: 'note',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '财务备注',
            align: "center",
            width: 180,
            dataIndex: 'fmsNote',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text === null || text === '' ? "暂无" : text}</p></Tooltip>,
        }, {
            title: '开票状态',
            align: "center",
            width: 80,
            dataIndex: 'invoiceStatus',
            render: (text) => text === 1 ? "已开票" : "未开票"
        }, {
            title: '发票类型',
            align: "center",
            width: 180,
            dataIndex: 'invoiceTypeName',
            render: (text) => text === null || text === '' ? "暂无" : text
        },
    ];

    const columns = (str: FullOrderEnum) => {
        switch (str) {
            case FullOrderEnum.purchase:
                return purchaseColumns
            case FullOrderEnum.sale:
                return saleColumns
            case FullOrderEnum.repair:
                return repairColumns
            case FullOrderEnum.ciRepair:
                return repairColumns
            case FullOrderEnum.bus:
                return busColumns
        }
    };

    const loadData = (str: FullOrderEnum) => {
        switch (str) {
            case FullOrderEnum.purchase:
                return purchaseLoadData(initPgCfg)
            case FullOrderEnum.sale:
                return saleLoadData(initPgCfg)
            case FullOrderEnum.repair:
                return repairLoadData(initPgCfg)
            case FullOrderEnum.ciRepair:
                return repairLoadData(initPgCfg)
            case FullOrderEnum.bus:
                return busSaleLoadData(initPgCfg)
        }
    };

    useEffect(() => {
        loadData(fullOrderStatus)
    }, [fullOrderStatus]);

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <Table
            rowKey={record => record.id as string}
            loading={loading}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    if (fullOrderStatus === FullOrderEnum.purchase) {
                        purchaseLoadData({ pageNum, pageSize })
                    } else if (fullOrderStatus === FullOrderEnum.sale) {
                        saleLoadData({ pageNum, pageSize })
                    } else if (fullOrderStatus === FullOrderEnum.repair) {
                        repairLoadData({ pageNum, pageSize })
                    } else if (fullOrderStatus == FullOrderEnum.ciRepair) {
                        repairLoadData({ pageNum, pageSize })
                    } else if (fullOrderStatus === FullOrderEnum.bus) {
                        busSaleLoadData({ pageNum, pageSize })
                    }
                }
            }}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowCode = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowCode])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowCode.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns(fullOrderStatus)}
            dataSource={dataSource}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
